(function (angular, app) {
   "use strict";

   app.modules.group = {
      name: "app.Group"
      , constants: {    
         handicapTypes: [
            { id: 1, name: "Official", displayName: 'Official' },
            { id: 2, name: "Trend", displayName: 'Trend' },
            { id: 3, name: "ManualEntry", displayName: 'Manual Entry' },
            { id: 4, name: "GroupScores", displayName: 'Group Scores' },
            { id: 5, name: "League", displayName: 'League' },
            { id: 6, name: "WorldAm", displayName: 'World Am' }
         ]
      }
      , controllers : { 
      }
      , decorators : {
      }
      , directives: {
         grouppicker: "ggGroupPickerDirective"
      }
      , filters : {
      }
      , services : {
         groups: "gg_GroupServiceFactory"
      }
      , routes : {
         lookup : {
            path : "/group/lookup"
            , controller : "gg_GroupLookupController"
            , controllerAs : "ggGroupLookupCtrl"
            , templateUrl : "app/group/controllers/grouplookup.html"
            , features : {
               showHeading : true
            }
            , accessControl : {
                roles: ["AUTHENTICATED"]
                , roleCheckType : 1 //app.modules.core.types.roleCheckType.atLeastOne
            }
         }
         , setup: {
            path: "/group/setup"
            , controller: "gg_GroupSetupController"
            , controllerAs: "ggGroupSetupCtrl"
            , templateUrl: "app/group/controllers/groupsetup.html"
            , features: {
               showHeading: true
            }
            , accessControl: {
               roles: ["AUTHENTICATED"]
                , roleCheckType: 1 //app.modules.core.types.roleCheckType.atLeastOne
            }
         }
         , detail: {
            path: "/group/detail"
            , controller: "gg_GroupDetailController"
            , controllerAs: "ggGroupDetailCtrl"
            , templateUrl: "app/group/controllers/groupdetail.html"
            , features: {
               showHeading: true
            }
            , accessControl: {
               roles: ["AUTHENTICATED"]
                , roleCheckType: 1 //app.modules.core.types.roleCheckType.atLeastOne
            }
         }
      }
   };
   
   angular.module(app.modules.group.name, []);

}(angular, app));
